module.exports = __webpack_public_path__ + "img/zhenchagenzong.a75772d5.png";